import Image from 'app/Components/Shared/Image/image';
import React, {useCallback} from 'react';
import Config from '../../../../Config';
import {seperateLinks} from 'app/Components/Block/HeaderMainBlock/constants';
import Tab from 'app/Components/Block/HeaderMainBlock/Desktop/Tab';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';

const TabMenu = ({props}) => {
  const {headerData: {tabIndex, tabs}, context, isBusinessNavigation} = props;

  const handleOnClick = useCallback((item, index) => {
    // Save the current tab index before navigating to the new tab
    history.replaceState({ tabIndex: tabIndex }, '');

    prepareSameWindowUrlWithNavigateTo(item?.link?.value, context);
  }, [context, tabIndex]);

  const className = isBusinessNavigation || (tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.isBusinessTab?.value === true) ? 'business' : '';
  return (
    <div className={`${className} header-top-menu`}>
      {tabs?.map((tab, index) => (
        <Tab key={'tab' + index} props={props} tab={tab} index={index} />
      ))}
      <div className="links-left-items">
        {tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.links?.expandedValue?.map((item, i) => (<div
            key={'link' + i}
            className={`${tabs[tabIndex]?.links?.expandedValue?.length === 1 ? 'only-1' : ''} link-wrapper`}
            onClick={() => handleOnClick(item, i)}>
            {item?.menuImage?.value !== null && (
              <Image style={{marginLeft: '4px'}} src={Config.epiBaseUrl + item?.menuImage?.expandedValue?.url}
                   alt={'item-icon'} />
            )}
            <span
              className={`${className} link-item`}>{item.text?.value}</span>
            {i !== 0 && <span className={'seperate-small-item'}>{seperateLinks.small}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabMenu;
